import { Phone } from 'lucide-react';

import { navigationSections } from '../content';
import { siteConfig } from '../../../shared/config/site';
import { scrollToSection } from '../../../shared/lib/scroll';

export function HeaderSection() {
  return (
    <header className="border-b border-white/10 bg-neutral-950">
      <div className="mx-auto flex max-w-[var(--container-max)] items-center justify-between gap-4 px-[var(--section-padding-x)] py-3">
        <a href="#top" className="min-w-0">
          <p className="font-display text-2xl font-semibold uppercase leading-none tracking-wide text-primary-400 sm:text-3xl">
            Inshore
          </p>
          <p className="mt-1 truncate text-xs text-white/60 sm:text-sm">{siteConfig.menuTagline}</p>
        </a>
        <nav className="hidden items-center gap-2 md:flex lg:gap-4" aria-label="Primary">
          {navigationSections.map((item) => (
            <button
              key={item.id}
              type="button"
              onClick={() => scrollToSection(item.id)}
              className="inline-flex min-h-11 min-w-11 items-center justify-center px-3 text-base font-medium tracking-wide text-white/70 transition hover:text-white"
            >
              {item.label}
            </button>
          ))}
        </nav>
        <a
          href={siteConfig.phoneHref}
          className="inline-flex min-h-11 items-center gap-2 rounded-md border border-primary-400/70 bg-transparent px-3 text-sm font-semibold text-primary-300 transition hover:border-primary-300 hover:bg-primary-400/10 hover:text-primary-200 sm:px-4"
        >
          <Phone className="h-4 w-4" aria-hidden="true" />
          <span className="hidden sm:inline">{siteConfig.phoneDisplay}</span>
          <span className="sm:hidden">Call</span>
        </a>
      </div>
    </header>
  );
}
